// API Configuration
// Environment variables from Vite (import.meta.env)

export const config = {
  // API URLs - Use relative URLs to leverage Vite proxy (proxies to backend via /api → localhost:8080)
  apiUrl: import.meta.env.VITE_API_URL || '/api',
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || '',

  // Frontend URLs
  userAppUrl: import.meta.env.VITE_USER_APP_URL || 'https://app.localhost',
  adminAppUrl: import.meta.env.VITE_ADMIN_APP_URL || 'https://admin.localhost',
  websiteUrl: import.meta.env.VITE_WEBSITE_URL || 'https://localhost',

  // Environment
  env: import.meta.env.VITE_ENV || 'development',
  isDevelopment: import.meta.env.DEV,
  isProduction: import.meta.env.PROD,

  // Google OAuth
  googleClientId: import.meta.env.VITE_GOOGLE_CLIENT_ID || null,

  // App settings
  appName: 'CaninCloud',
  appVersion: '2.0.0',

  // Token storage keys
  tokenKey: 'accessToken',
  refreshTokenKey: 'refreshToken',
  userKey: 'currentUser',

  // Inactivity timeout (in milliseconds)
  // User: 60 minutes = 3,600,000 ms
  inactivityTimeout: 60 * 60 * 1000,  // 60 minutes
  inactivityWarningTime: 60 * 1000    // Show warning 60 seconds before timeout
};

export default config;
